var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.533203,
    y: 0.949707,
    width: 30.3535,
    height: 30.3535,
    rx: 15.1768,
    fill: "#E9EAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4584 20.7743C20.6325 19.3515 19.3104 18.2835 17.7456 17.7753C18.4957 17.3293 19.0785 16.6494 19.4046 15.84C19.7307 15.0307 19.7821 14.1366 19.5509 13.2952C19.3196 12.4538 18.8185 11.7116 18.1245 11.1827C17.4305 10.6537 16.582 10.3672 15.7094 10.3672C14.8368 10.3672 13.9884 10.6537 13.2944 11.1827C12.6004 11.7116 12.0993 12.4538 11.868 13.2952C11.6367 14.1366 11.6881 15.0307 12.0142 15.84C12.3404 16.6494 12.9232 17.3293 13.6732 17.7753C12.1085 18.2835 10.7864 19.3515 9.96044 20.7743C9.91988 20.841 9.89844 20.9176 9.89844 20.9956C9.89844 21.0737 9.91988 21.1502 9.96044 21.217C9.99827 21.2848 10.0537 21.3411 10.1209 21.3801C10.1881 21.4191 10.2646 21.4392 10.3422 21.4383H21.0766C21.1543 21.4392 21.2307 21.4191 21.2979 21.3801C21.3651 21.3411 21.4206 21.2848 21.4584 21.217C21.499 21.1502 21.5204 21.0737 21.5204 20.9956C21.5204 20.9176 21.499 20.841 21.4584 20.7743Z",
    fill: "#AFB2B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/Profiles.858d4bd2706d2d84595fc4c3ee4ca215.svg";
export { ForwardRef as ReactComponent };